// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';
import {TopHandles, BottomHandles, LeftHandles, RightHandles} from '../Handles';

import './OverviewDiagram.scss';

type OverviewDiagramTextNodeData = {|
  text: string,
|};

type OverviewDiagramNodeProps = {|
  data: OverviewDiagramTextNodeData,
|};

export const OverviewDiagramTextNode = ({data}: OverviewDiagramNodeProps) => {
  const {text} = data;

  return (
    <Box
      className="OverviewDiagramTextNode"
      flex={{alignItems: 'center', justifyContent: 'center'}}
      background="white"
      padding={16}
    >
      <TopHandles />
      <LeftHandles />
      <BottomHandles />
      <Box flexBasis="100%" flex={{alignItems: 'center', direction: 'column'}}>
        <BodyAlt align="center" color={'gray900'}>
          {text}
        </BodyAlt>
      </Box>
      <RightHandles />
    </Box>
  );
};
